<template>
  <div class="orderIndex">
    <div class="t_search">
      <!-- tab切换 -->
      <div class="b_box_tabs">
        <!-- <span v-for="(item,index) in tableList" :key="index" :class="listQuery.status == item.index?'active br4':'br4'" @click="handleChangeStatus(item.index)">{{item.title}}</span> -->
        <el-radio-group v-model="listQuery.status" @change="handleChangeStatus" fill="#31b158">
          <el-radio-button :label="item.index" v-for="(item,index) in tableList" :key="index">{{item.title}}</el-radio-button>
        </el-radio-group>
      </div>
      <!-- 搜索 -->
      <div class="input_s br4">
        <div class="list_search br4">
          <input type="text" v-model="listQuery.name" @input="handleInput()" placeholder="搜索买家名/商品名" />
          <span class="icon_search"><i class="iconfont icon-sousuo" style="color:#888"></i></span>
          <span class="icon_close" v-if="listQuery.name" @click="listQuery.name = '';handleInput()">
            <i class="iconfont icon-guanbi" style="color:#888"></i>
          </span>
        </div>
      </div>
      
      <!-- 时间选择 -->
      <div class="time_s">
        <Calendar v-model="data_picker" @change="changeTime"></Calendar>
      </div>

      <div class="total">
        共 <span>{{totalNum}}</span> 个订单
      </div>
    </div>
    <!-- 列表 -->
    <div class="listBox">
      <md-scroll-view ref="scrollView" :auto-reflow="true" :manual-init="true" :scrolling-x="false" @end-reached="$_onEndReached">
        <div class="list" @click="lookDetail(item.order_sn)" v-for="(item,index) in list" :key="index">
          <div class="listDetail">
            <div class="item1">
              <div>
                <span>日单号：{{item.day_num}}</span>
              </div>
              <div>
                <span v-if="item.status==0" style="background:rgba(255,102,0,0.3);color:#FF6600">待支付</span>
                <span v-if="item.status==1" style="background:rgba(49,177,88,0.3);color:#31B158">结清</span>
                <span v-if="item.status==2" style="background:rgba(255,0,0,.3);color:#FF0000">赊欠</span>
                <span v-if="item.status==3" style="background:rgba(153,153,153,.3);color:#999">作废</span>
                <span v-if="item.status==4" style="background:rgba(255,0,0,.3);color:#FF0000">退款</span>
              </div>
            </div>
            <div class="item2">
              <div class="mand-ellipsis">
                <span>{{item.buyer_name}}</span>
              </div>
              <div>
                <span>
                  <span v-for="(item_good,good_index) in item.goods" :key="good_index"><span v-if="good_index>0">，</span>{{item_good.name}} 
                  </span>
                </span>
              </div>
            </div>
            <div class="item3">
              <div>
                <span><span style="font-size:0.16rem">￥</span>{{item.amount*1}}</span>
              </div>
              <div>
                <span>订单金额</span>
              </div>
            </div>
            <div class="item4">
              <template v-if="Number(item.last_credit)>0">
                <div>
                  <span><span style="font-size:0.16rem">￥</span>{{Number(item.last_credit)?item.last_credit*1:0}}</span>
                </div>
                <div>
                  <span>赊欠</span>
                </div>
              </template>
            </div>
            <div class="item5">
              <template v-if="item.remarks">
                <div v-if="item.remarks" class="mand-ellipsis">
                  <span>备注:{{item.remarks}}</span>
                </div>
              </template>
              <template v-else>
                <div>
                  <span>收银员：{{item.user_realname}}</span>
                </div>
              </template>
              <div>
                <span>{{item.create_time|toTime}}</span>
              </div>
            </div>
            <div class="item6">
              <div>
                <md-icon name="arrow-right" size="md"></md-icon>
              </div>
            </div>
          </div>
          <div class="imgbox">
            <img
              v-if="item.status==4"
              src="../../../assets/img/work/order_manage/refuseOrder.png"
              alt
            />
            <img v-if="item.before_sn && item.status != 3 && item.status != 4" src="../../../assets/img/work/order_manage/editorOrder.png" alt="">
            <img
              v-if="item.status==3"
              src="../../../assets/img/work/order_manage/cancleOrder.png"
              alt
            />
          </div>
        </div>
        <md-scroll-view-more :finished-text="list.length>0?'全部已加载':'暂无数据'" slot="more"  :is-finished="isFinished"></md-scroll-view-more>
      </md-scroll-view>
      <div v-if="list.length==0" style="text-align:center;color:#999;line-height:0.8rem;background:#fff">暂无数据~</div>
    </div>
    <!-- 右边弹窗 详情-->
    <orderDetail :pop_show="isPopupShow"  :orderId="orderId" @cancel="close" @finish="updata"/>
    
  </div>
</template>
<script>
import orderDetail from './orderDetail'
import { timestampToDate, timestampToTime } from "@/utils/timestamp";
import { order_list, order_delete, order_print } from "@/api/work/order.js";
import Calendar from "@/components/Calendar"
export default {
  name:'orderIndex',
  components:{
    orderDetail,Calendar
  },
  data() {
    return {
      tableList: [
        { title: "全部", index: "" },
        { title: "已结清", index: "1" },
        { title: "赊欠", index: "2" },
        { title: "作废", index: "3" },
        { title: "退款", index: "4" },
        { title: "有备注", index: "-1" }
      ],
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" }
      ],
      data_picker:[],
      listQuery:{
        page:1,
        pageSize:30,
        status:'',
        is_desc:'', // 1 有备注
        name:'',
        s_time:'',
        e_time:'',
      },
      isFinished: false,
      isPopupShow: false, //是否显示右边详情
      totalNum: 0,
      list: [],

      nowIndex: 0, //当前点击tab
      searchName: "", //搜索的名称
      searchTime: [], //选择的时间
      page: 1,
      pageSize: 15,
      status: "",
      is_desc: "",
      totalNum: 0,
      printLoading: true,
      orderId:''
    };
  },
  created() {
    this.getList();
  },
  mounted() {},
  methods: {
    
    //选择时间
    changeTime(e){
      if(this.data_picker){
        this.listQuery.s_time = this.data_picker[0]
        this.listQuery.e_time = this.data_picker[1]
      }else{
        this.listQuery.s_time = ''
        this.listQuery.e_time = ''
      }
      this.listQuery.page = 1
      this.getList()
    },
    // 切换状态
    handleChangeStatus(val){
      this.listQuery.status = val
      this.listQuery.page = 1
      this.getList()
    },
    //获取列表
    getList() {
      // 有备注状态
      var listQuery = JSON.parse(JSON.stringify(this.listQuery))
      if(this.listQuery.status == -1){
        listQuery.is_desc = 1
        listQuery.status = ''
      }else{
        listQuery.is_desc = ''
      }
      order_list(listQuery).then(res => {
        if (res.code == 200) {
          this.totalNum = res.data.totalCount;
          if(listQuery.page == 1){ this.list = [];this.$refs.scrollView.scrollTo(0,0)}
          this.list = this.list.concat(res.data.list);

          if ( this.list.length == res.data.totalCount || res.data.list.length == 0 ) {
            this.isFinished = true;
          } else {
            this.isFinished = false;
            this.listQuery.page++;
          }
          this.$refs.scrollView.finishLoadMore();
          this.$refs.scrollView.init()
        }
      });
    },
    //获取输入搜索
    handleInput() {
      this.listQuery.page = 1;
      this.getList();
    },
    //详情页
    lookDetail(order_sn) {
      this.orderId = order_sn
      this.isPopupShow = true;
    },
    //下拉刷新
    $_onEndReached() {
      if (this.isFinished) {
        return;
      }
      // async data
      this.getList();
      this.$refs.scrollView.finishLoadMore();
    },
    close(){
      this.isPopupShow=false;
      this.orderId = ''
       this.listQuery.page = 1;
      this.getList();
    },
   updata(){
    //  this.listQuery.page = 1;
     
   }
  }
};
</script>
<style lang="less" scoped>
.orderIndex {
  position: relative;
  width: 100%;
  height: 100%;
  background: #e1e1e1;
  .t_search {
    height: 0.8rem;
    padding: 0 0.1rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    background: #fff;
    position: relative;
    box-shadow: 0 0.02rem 0.04rem 0.02rem rgba(221, 221, 221, 0.5);
    z-index: 2;
    ul {
      display: flex;
      justify-content: center;
      align-items: center;
      li {
        background: #fff;
        padding: 0.08rem 0.22rem;
        margin-right: 0.06rem;
        border-radius: 0.04rem;
        color: #31b158;
        font-size: 0.2rem;
      }
    }
    .b_box_tabs{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-left: 0.01rem;
        span{
            min-width: 0.85rem;
            padding: 0.16rem;
            height: 0.6rem;
            margin-right: 0.05rem;
            font-size: 0.24rem;
            background-color: #fff;
            border: 0.02rem solid #31B158;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            &.active{
                background-color: #31B158;
                color: #fff;
            }
        }
    }
    .input_s {
      width: 2.4rem;
      overflow: hidden;
      position: relative;
      margin-left: 0.1rem;
      .list_search {
        width: 100%;
        height: 0.5rem;
        box-sizing: border-box;
        padding: 0;
        position: relative;
        input {
          line-height: 0.5rem;
          font-size: 0.2rem;
          border: none;
          outline: none;
          background-color: #e6e6e6;
          width: 100%;
          text-indent: 0.4rem;
        }
        span{
          top: 0.14rem;
        }
        span.icon_search{
          left: 0.12rem;
        }
      }
    }
    .time_s {
      margin-left: 0.1rem;
      border-radius: 0.04rem;
      color: #404040;
      display: flex;
      align-items: center;
      // width: 2.4rem;
    }
    .total {
      font-size: 0.2rem;
      margin-left: 0.2rem;
      display: felx;
      align-items: center;
      position: absolute;
      right: 0.1rem;
      font-size: 0.24rem;
      margin-right: 0.1rem;
      span {
        color: #31b158;
      }
    }
    .active { 
      color: #404040;
    }
  }
  .listBox {
    height: calc(100% - 0.8rem);
    .list {
      background: #fff;
      margin: 0 0.1rem;
      font-size: 0.2rem;
      padding: 0.12rem 0.32rem;
      border-radius: 0.04rem;
      margin-top: 0.1rem;
      position: relative;
      .imgbox {
        width: 0.5rem;
        height: 0.5rem;
        position: absolute;
        right: 0.86rem;
        top: 50%;
        transform: translateY(-50%);
        img {
          width: 100%;
          height: 100%;
        }
      }
      .listDetail {
        display: flex;
        justify-content: space-between;
        max-height: 0.8rem;
        &>div{
          &>div:nth-child(1){
            line-height: 0.36rem;
          }
        }
        .item1 {
          display: flex;
          flex-direction: column;
          justify-content: center;
          div:nth-of-type(1) {
            width: 1.4rem;
          }
          div:nth-of-type(2) {
            width: 0.8rem;
            display: flex;
            // margin-top: 0.06rem;
            justify-content: center;
            span:nth-of-type(1) {
              padding: 0rem 0.1rem;
              color: #fff;
              border-radius: 0.12rem;
              font-size: 0.18rem;
              line-height: 0.24rem;
            }
          }
        }
        .item2 {
          display: flex;
          flex-direction: column;
          width: 2.5rem;
          justify-content:center;
          div:nth-of-type(1) {
            color: #404040;
            font-size: 0.24rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          div:nth-of-type(2) {
            color: #999;
            // margin-top: 0.06rem;
            font-size: 0.2rem;
            width: 2rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
        .item3 {
          display: flex;
          flex-direction: column;
          width: 1.6rem;
          justify-content: center;
          // text-align: right;
          div:nth-of-type(1) {
            color: #404040;
            font-size: 0.24rem;
            // font-weight: bold;
          }
          div:nth-of-type(2) {
            color: #999;
            // margin-top: 0.06rem;
            font-size: 0.2rem;
          }
        }
        .item4 {
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 1.2rem;
          // text-align: right;
          div:nth-of-type(1) {
            color: #f79a07;
            font-size: 0.24rem;
            // font-weight: bold;
          }
          div:nth-of-type(2) {
            color: #999;
            // margin-top: 0.06rem;
            font-size: 0.2rem;
          }
        }
        .item5 {
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 2.6rem;
          color: #999999;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .item6 {
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 0.6rem;
          justify-content: center;
          div:nth-of-type(1) {
            display: flex;
            justify-content: flex-end;
          }
        }
      }
    }
    .empty {
      text-align: center;
    }
  }
}
</style>


<style lang="less">
.orderIndex{
  .el-radio-group{
    .el-radio-button {
      .el-radio-button__inner{
        width: 0.9rem;
        font-size: 0.22rem;
        padding:0.07rem 0;
        line-height: 0.34rem;
        border-width: 0.01rem;
        border-color: #31B158;
      }
    }
  }
  .calendar_select_box{
    height: 0.5rem !important;
  }
}
</style>